import useScrollPosition from 'hook/useScroll';
import { useEffect, useState } from 'react';
import styles from './navigation-desktop.module.scss';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';

const OFFSET_Y_TO_STICKY_HEADER = 83;

const NavigationDesktop = () => {
  const { t } = useTranslation('header');

  //--- Scroll header
  const scrollPosition = useScrollPosition();
  const [isShowStickyHeader, setIsShowStickyHeader] = useState(false);

  useEffect(() => {
    if (scrollPosition > OFFSET_Y_TO_STICKY_HEADER) {
      setIsShowStickyHeader(true);
    } else {
      setIsShowStickyHeader(false);
    }
  }, [scrollPosition]);

  return (
    <div className={`hidden xl:block ${isShowStickyHeader ? styles.headerContainerSticky : ''}`}>
      <ul
        className={`flex items-center justify-center gap-x-9 text-white font-semibold uppercase ${
          isShowStickyHeader ? 'py-6' : 'mt-6'
        }`}
      >
        <li className="cursor-pointer">
          <Link
            activeClass="border-b border-white pb-1"
            to="aboutUs"
            hashSpy={true}
            spy={true}
            smooth={true}
            offset={-90}
          >
            {t('navigation.introduction')}
          </Link>
        </li>
        <li className="cursor-pointer">
          <Link
            activeClass="border-b border-white pb-1"
            to="menu"
            hashSpy={true}
            spy={true}
            smooth={true}
            offset={-90}
          >
            {t('navigation.menu')}
          </Link>
        </li>
        <li className="cursor-pointer">
          <Link
            activeClass="border-b border-white pb-1"
            to="feedback"
            hashSpy={true}
            spy={true}
            smooth={true}
            offset={-90}
          >
            {t('navigation.feedback')}
          </Link>
        </li>
        <li className="cursor-pointer">
          <Link
            activeClass="border-b border-white pb-1"
            to="service"
            hashSpy={true}
            spy={true}
            smooth={true}
            offset={-90}
          >
            {t('navigation.service')}
          </Link>
        </li>
        <li className="cursor-pointer">
          <Link
            activeClass="border-b border-white pb-1"
            to="news"
            hashSpy={true}
            spy={true}
            smooth={true}
            offset={-90}
          >
            {t('navigation.news')}
          </Link>
        </li>
        <li className="cursor-pointer">
          <Link
            activeClass="border-b border-white pb-1"
            to="contactUs"
            hashSpy={true}
            spy={true}
            smooth={true}
            offset={-90}
          >
            {t('navigation.contact')}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default NavigationDesktop;
